<style lang="less">
    html.dark .dialog-mask {
        opacity: 1;
    }
    .dialog-mask {
        position: fixed;
        z-index: 100;
        background-color: var(--bg-color-dialog-mask);
        opacity: 0.5;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
</style>

<template>
    <div class="dialog-mask" v-show="showDialogMaskprop | showDialogMask" @click.stop></div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class DialogMask extends Vue {
        // 组件方法也可以直接声明为实例的方法
        get showDialogMask() {
            return this.$store.state.dialog.showDialogMask;
        }
        @Prop({ default: false }) showDialogMaskprop!: Boolean;

        //生命周期
        mounted() {}

        created() {}
    }
</script>
